import { PropsWithChildren } from "react";
import SideBar from "./side-bar";
import MainHeader from "./main-header";
import QuickStartButton from "../shared/quick-start-button";

const CommonLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="h-screen w-full min-w-0">
      <MainHeader />
      <div className="flex min-h-common-height w-full">
        <SideBar />
        <div className="w-full">{children}</div>
      </div>
      <QuickStartButton />
    </div>
  );
};

export default CommonLayout;
